import { useEffect, useState } from 'react';

export function useCreditorFilters(companyId) {
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');
  const [qDebounced, setQDebounced] = useState('');
  const [status, setStatus] = useState('ativo');
  const [supplier, setSupplier] = useState('');
  const [employee, setEmployee] = useState('S');

  useEffect(() => {
    const t = setTimeout(() => setQDebounced(q), 350);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    setPage(1);
  }, [qDebounced, status, supplier, employee, companyId]);

  return {
    page,
    setPage,
    q,
    setQ,
    qDebounced,
    status,
    setStatus,
    supplier,
    setSupplier,
    employee,
    setEmployee,
  };
}
